import { defineMessages } from 'react-intl';

export default defineMessages({
  shipFromLabel: {
    defaultMessage: 'Ship From Address',
    description: 'Label for the ship from address field',
    id: 'aOStGT',
  },
  editShipFromAddressButton: {
    description: 'Label for the button that will edit an address',
    defaultMessage: 'Edit',
    id: 'm4HTJN',
  },
});
